import React from "react"
import { Separator } from "../course-ui-components/SeparatorPadding"

export const CourseDescription = props => (
  <div>
      {
          props.description.map((item, index) => {
              return (
                <div  key={index}>
                    {item.title ? <div className="text-paragraph-title" dangerouslySetInnerHTML={{ __html: item.title }} /> : <noscript />}

                    <div dangerouslySetInnerHTML={{ __html: item.text}} />

                    <Separator size="lg"/>
                </div>
              )
          })
      }
  </div>
)
